import { Injectable } from '@angular/core';
import * as L from 'leaflet';
import { PortalGroupApiService } from 'src/app/shared/api/services/portal-group-api.service';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { PortalGroup } from 'src/app/data/model/portal-group';

@Injectable({
  providedIn: 'root'
})
export class GroupMarkerService {
  constructor(
    private apiGroupService: PortalGroupApiService,
  ) { }

  private groupsSubject = new BehaviorSubject<PortalGroup[] | null>(null);
  
  get groups$(): Observable<PortalGroup[] | null> {
    return this.groupsSubject.asObservable();
  }

  loadGroups() {
    this.apiGroupService
      .getAll()
      .pipe(tap((res:any) => this.groupsSubject.next(res.results)))
      .subscribe((res:any) => {
        let point//L.LatLng
        for (const c of res.results) {
          const coords = c.center_coords.split(" ")
          const mark1= coords[1].split("(")
          const mark2= coords[2].split(")");

          point=(mark2[0], mark1[1])
        }
        return point
      });
  }

}
